const __request = require(`../__request/__request_contentType_json`);

// 国内退票申请
export default (data) => {
let pParameter = {
    method: 'post',
    urlSuffix: '/buyer/dom/white/refund',
    data:data
  }

  return __request(pParameter)
}

